<template>
  <a ref="tooltiplink" rel="tooltip" data-toggle="tooltip" :data-placement="placement" :data-original-title="label" @click.prevent="onClicked" :class="{'tooltip-help-style': helpStyle, 'tooltip-link-style': linkStyle}">
    <slot />
  </a>
</template>

<style scoped>
.tooltip-help-style {
  text-decoration: underline dotted !important;
  cursor: help;
}
.tooltip-link-style {
  cursor: pointer;
}
</style>

<script>
export default {
  name: "Tooltip",
  props: {
    label: String,
    placement: {
      type: String,
      default: 'bottom',
    },
    helpStyle: {
      type: Boolean,
      default: false
    },
    linkStyle: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
  },
  beforeDestroy() {
  },
  updated() {
    $(this.$refs.tooltiplink).tooltip('update')
  },
  methods: {
    onClicked(evt) {
      // Close the tooltip. It gets sticky if opening a page on click
      $(this.$refs.tooltiplink).tooltip('hide')

      this.$emit('click', evt)
    }
  }
}
</script>